<template>
    <div class="tokens-delete">
        <button class="button button--blank" @click.prevent="showConfirm = true">
            <IconBin fill="red" />
        </button>
        <ConfirmModal
            v-if="showConfirm"
            :title="$t('crm.tokens.delete.title')"
            :ok-label="$t('misc.delete')"
            @confirmed="deleteToken"
            @canceled="showConfirm = false"
        >
            <template #content>
                <Spinner v-if="loading" />
                <TransitionExpand v-if="error">
                    <ErrorList :error="error" />
                </TransitionExpand>
            </template>
        </ConfirmModal>
    </div>
</template>

<script>
import { deleteCustomersMembersToken } from '../../api/tokens';
import { IconBin } from '@speechki-frontend/shared/ui/icons';
import { ConfirmModal } from '@speechki-frontend/shared/ui/modals';
import { ErrorList } from '@speechki-frontend/shared/ui/forms';
import TransitionExpand from '@speechki-frontend/shared/ui/TransitionExpand';
import Spinner from '@speechki-frontend/shared/ui/Spinner';
import { mapActions } from 'vuex';

export default {
    name: 'TokensDelete',
    components: {
        IconBin,
        ConfirmModal,
        TransitionExpand,
        ErrorList,
        Spinner,
    },
    props: {
        token: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showConfirm: false,
            loading: false,
            error: null,
        };
    },
    methods: {
        ...mapActions(['pushToast']),

        async deleteToken() {
            this.loading = true;
            this.error = undefined;

            try {
                await deleteCustomersMembersToken(this.token.id);
                this.$emit('deleted', this.token);
                this.pushToast({
                    id: Date.now(),
                    type: 'success',
                    title: this.$t('crm.tokens.delete.success'),
                });
                this.showConfirm = false;
            } catch (err) {
                this.error = err;
                console.log(err);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
